import { createContext, useContext } from 'react';

import { Platform } from '@constants';

export interface GlobalState {
  platform: Platform;
  version: string;
  os: string | undefined;
  device: string | undefined;
  isTablet: boolean;
  isCheming: boolean;
  goodsName: string;
  serviceName: string;
  chatName: string;
}

const initialState: GlobalState = {
  platform: Platform.web,
  version: '1.0.0,',
  os: '',
  device: '',
  isTablet: false,
  isCheming: false,
  goodsName: '',
  serviceName: '',
  chatName: '',
};

const GlobalContext = createContext(initialState);

export const GlobalProvider = GlobalContext.Provider;

export const useGlobalContext = () => {
  return useContext(GlobalContext);
};

export const useMobile = () => {
  const { platform } = useGlobalContext();
  return platform === Platform.ios || platform === Platform.android;
};
